<div class="dynamic-input-form" [formGroup]="form">
	<mat-slide-toggle color="primary" labelPosition="before" [formControlName]="question.key" [id]="question.key">
		{{ question.label }}
	</mat-slide-toggle>
</div>
